import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
const b = bemClassBuilder('v-film-image');
export const FilmImageSkeleton = ({ mediaType }) => (_jsx("div", { className: b.block({ mediaType, skeleton: true }) }));
